<template>
  <div>
    <el-form
      v-show="currentPage === 1"
      ref="page1"
      :model="item"
      label-position="left"
      label-width="160px"
    >
      <el-form-item label="Material Mode">
        <el-radio-group v-model="item.material_type" @change="switchLabel">
          <el-radio :label="CONSTANT.MATERIAL_TYPE.IMAGES">Images</el-radio>
          <el-radio :label="CONSTANT.MATERIAL_TYPE.HTML">Html</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item label="Size" prop="size" :rules="sizeRule('size')">
        <el-select
          v-model="item.size"
          filterable
          allow-create
          default-first-option
        >
          <el-option
            v-for="option in size_option"
            :key="option"
            :label="option"
            :value="option"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <el-form
      ref="page2"
      v-show="currentPage === 2"
      :model="item"
      style="position: relative"
    >
      <div style="position: absolute; right: 0px; top :0px; display: flex">
        <el-button
          @click="addCondition()"
          :disabled="item.conditions.length >= 10"
        >
          <i class="fas fa-plus"></i>
        </el-button>
        <el-button @click="remove()" :disabled="item.conditions.length <= 1"
          ><i class="fas fa-trash-alt"></i
        ></el-button>
      </div>
      <el-tabs v-model="tab" type="card" tab-position="top">
        <el-tab-pane
          v-for="(condition, index) in item.conditions"
          :key="index"
          :label="(index + 1).toString()"
          :name="(index + 1).toString()"
        >
          <el-form-item
            label="Name"
            :prop="`conditions.${index}.name`"
            label-width="120px"
          >
            <el-input
              v-model="condition.name"
              :disabled="index === 0"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="Landing Page"
            :prop="`conditions.${index}.landing_page`"
            :rules="urlRule('landing_page')"
            label-width="120px"
          >
            <el-input v-model="condition.landing_page"></el-input>
          </el-form-item>
          <el-form-item
            v-if="item.material_type === CONSTANT.MATERIAL_TYPE.IMAGES"
            label="Image"
            :prop="`conditions.${index}.image_url`"
            :rules="[
              ...imageSizeRule(limited_size.image),
              ...urlRule('image_url'),
            ]"
            label-width="120px"
            style="width:100%;"
          >
            <file-input
              accept="image/jpeg, image/png, image/gif"
              v-model="condition.image_url"
              :check_upload_image_size="{
                ...limited_size.image,
                enable: true,
              }"
            >
            </file-input>
          </el-form-item>
          <el-form-item
            v-if="item.material_type === CONSTANT.MATERIAL_TYPE.HTML"
            label="Html"
            :prop="`conditions.${index}.html_url`"
            :rules="urlRule('html_url')"
            label-width="120px"
          >
            <file-input
              accept="application/zip, application/x-zip-compressed, application/zip-compressed"
              v-model="condition.html_url"
            ></file-input>
          </el-form-item>
          <div
            class="condtion_graybox"
            style="border-radius: 10px 10px 0px 0px"
          >
            <el-form-item
              label="Time"
              label-width="120px"
              :prop="`conditions.${index}.time_duration`"
            >
              <el-time-picker
                :disabled="index === 0"
                is-range
                v-model="condition.time_duration"
                range-separator="to"
                start-placeholder="start time"
                end-placeholder="end time"
                placeholder="choose duration"
              >
              </el-time-picker>
              <el-checkbox
                v-model="condition.time_duration_display"
                :disabled="index === 0"
              >
                display on creatives
              </el-checkbox>
            </el-form-item>
          </div>
          <div class="condtion_graybox">
            <el-form-item label="Weather" label-width="120px">
              <el-select
                v-model="condition.weather"
                :disabled="index === 0"
                clearable
              >
                <el-option
                  v-for="option in weather_option"
                  :key="option"
                  :label="option"
                  :value="option"
                >
                </el-option>
              </el-select>
              <el-checkbox
                v-model="condition.weather_display"
                :disabled="index === 0"
              >
                display on creatives
              </el-checkbox>
            </el-form-item>
          </div>
          <div class="condtion_graybox">
            <el-form-item label="Humidity (%)" label-width="120px">
              <div style="display:flex;">
                <el-form-item
                  label="min"
                  style="display: flex;"
                  :prop="`conditions.${index}.humidity_min`"
                  :rules="[
                    ...minNumberRule(0),
                    ...maxNumberRule(
                      item.conditions[index].humidity_max || 100
                    ),
                  ]"
                >
                  <el-input
                    :disabled="index === 0"
                    type="number"
                    placeholder="input number"
                    v-model.number="condition.humidity_min"
                    style="width:180px;"
                    @change="checkForm()"
                  >
                    <template slot="append">
                      %
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="max"
                  style="display: flex; margin-left: 36px;"
                  :prop="`conditions.${index}.humidity_max`"
                  label-width="60px;"
                  :rules="[
                    ...minNumberRule(0 || item.conditions[index].humidity_min),
                    ...maxNumberRule(100),
                  ]"
                >
                  <el-input
                    :disabled="index === 0"
                    type="number"
                    placeholder="input number"
                    v-model.number="condition.humidity_max"
                    style="width:180px;"
                    @change="checkForm()"
                  >
                    <template slot="append">
                      %
                    </template>
                  </el-input>
                </el-form-item>
              </div>
              <el-checkbox
                v-model="condition.humidity_display"
                :disabled="index === 0"
              >
                display on creatives
              </el-checkbox>
            </el-form-item>
          </div>
          <div class="condtion_graybox">
            <el-form-item label="Temperature" label-width="120px">
              <div style="display:flex;">
                <el-form-item
                  label="min"
                  style="display: flex;"
                  :prop="`conditions.${index}.temperature_max`"
                  :rules="[
                    ...minNumberRule(-20),
                    ...maxNumberRule(
                      item.conditions[index].temperature_max || 100
                    ),
                  ]"
                >
                  <el-input
                    :disabled="index === 0"
                    type="number"
                    placeholder="input number"
                    v-model.number="condition.temperature_min"
                    style="width:120px;"
                    @change="checkForm()"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="max"
                  style="display: flex; margin-left: 48px;"
                  :prop="`conditions.${index}.temperature_min`"
                  :rules="[
                    ...minNumberRule(
                      -20 || item.conditions[index].temperature_min
                    ),
                    ...maxNumberRule(100),
                  ]"
                >
                  <el-input
                    :disabled="index === 0"
                    type="number"
                    placeholder="input number"
                    v-model.number="condition.temperature_max"
                    style="width:120px;"
                  >
                  </el-input>
                </el-form-item>
                <el-form-item>
                  <el-radio-group
                    text-color="#EF767A"
                    v-model="condition.temperature_unit"
                  >
                    <el-radio-button :label="CONSTANT.TEMPERATURE_TYPE.C"
                      >°C</el-radio-button
                    >
                    <el-radio-button :label="CONSTANT.TEMPERATURE_TYPE.F"
                      >°F</el-radio-button
                    >
                  </el-radio-group>
                </el-form-item>
              </div>
              <el-checkbox
                v-model="condition.temperature_display"
                :disabled="index === 0"
              >
                display on creatives
              </el-checkbox>
            </el-form-item>
          </div>
          <div
            class="condtion_graybox"
            style="border-radius:  0px 0px 10px 10px"
          >
            <el-form-item label-width="120px">
              <template slot="label">
                <div>
                  PM2.5
                  <el-popover trigger="hover" placement="top-start">
                    <i slot="reference" class="el-icon-info"></i>
                    <div>
                      <img src="@/assets/pm25.png" width="250" height="200" />
                    </div>
                  </el-popover>
                </div>
              </template>
              <div style="display:flex;">
                <el-form-item
                  label="min"
                  style="display: flex;"
                  :prop="`conditions.${index}.pm25_min`"
                  :rules="[
                    ...minNumberRule(0),
                    ...maxNumberRule(item.conditions[index].pm25_max || 500),
                  ]"
                >
                  <el-input
                    :disabled="index === 0"
                    type="number"
                    placeholder="input number"
                    v-model.number="condition.pm25_min"
                    style="width:180px; "
                    class="pm25"
                    @change="checkForm()"
                  >
                    <template
                      slot="append"
                      style="width: 12px;padding: 0px 8px;"
                    >
                      μg/m3
                    </template>
                  </el-input>
                </el-form-item>
                <el-form-item
                  label="max"
                  style="display: flex; margin-left: 48px;"
                  :prop="`conditions.${index}.pm25_min`"
                  :rules="[
                    ...minNumberRule(0 || item.conditions[index].pm25_min),
                    ...maxNumberRule(500),
                  ]"
                >
                  <el-input
                    :disabled="index === 0"
                    type="number"
                    placeholder="input number"
                    v-model.number="condition.pm25_max"
                    style="width:180px;"
                    class="pm25"
                    @change="checkForm()"
                  >
                    <template slot="append" class="x">
                      μg/m3
                    </template>
                  </el-input>
                </el-form-item>
              </div>
              <el-checkbox
                v-model="condition.pm25_display"
                :disabled="index === 0"
              >
                display on creatives
              </el-checkbox>
            </el-form-item>
          </div>
          <div
            v-if="
              condition.time_duration_display ||
                condition.weather_display ||
                condition.humidity_display ||
                condition.temperature_display ||
                condition.pm25_display
            "
          >
            <el-divider>
              <span class="blue">Condition display setting</span>
            </el-divider>
            <layout-item
              v-for="key in ['vertical']"
              :key="key"
              :label="_.capitalize(key)"
              :type="key"
              :min="0"
              :max="parseInt(item.size.split('x')[1])"
              v-model="condition.vertical"
              :prop="`conditions.${index}`"
            ></layout-item>
            <layout-item
              v-for="key in ['horizontal']"
              :key="key"
              :label="_.capitalize(key)"
              :type="key"
              :min="0"
              :max="parseInt(item.size.split('x')[0])"
              :prop="`conditions.${index}`"
              v-model="condition.horizontal"
            ></layout-item>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </div>
</template>

<script>
import MixFormRule from "@/components/mixins/formRule";
import MixCreativeForm from "@/components/mixins/creativeForm";
import formItemGroup from "../formItemGroup.vue";
const { DATA_DRIVEN } = CONSTANT.CREATIVE_DEFAULT_VALUE;
export default {
  components: { formItemGroup },
  props: {
    currentPage: {
      required: true,
      default() {
        return 1;
      },
    },
  },
  data() {
    return {
      tab: "1",
      item: {
        material_type: CONSTANT.MATERIAL_TYPE.IMAGES || 0,
        size: "300x250",
        conditions: [...Array(DATA_DRIVEN.MIN_NUM)].map(() =>
          _.cloneDeep(DATA_DRIVEN.ITEM)
        ),
      },
      time: "",
      size_option: [
        "300x250",
        "336x280",
        "320x50",
        "728x90",
        "300x100",
        "320x100",
        "160x600",
        "300x600",
        "320x480",
        "610x100",
        "970x250",
        "960x100",
      ],
      weather_option: ["Sunny", "Rainy", "Cloudy"],
    };
  },
  created() {
    this.init();
  },
  computed: {
    limited_size() {
      return {
        image: {
          width: {
            max: parseInt(this.item.size.split("x")[0]),
            min: parseInt(this.item.size.split("x")[0]),
          },
          height: {
            max: parseInt(this.item.size.split("x")[1]),
            min: parseInt(this.item.size.split("x")[1]),
          },
        },
      };
    },
  },
  mixins: [MixFormRule, MixCreativeForm],
  methods: {
    switchLabel(label) {
      if (label === CONSTANT.MATERIAL_TYPE.IMAGES) {
        this.item.conditions.forEach((element) => {
          element.html_url = null;
        });
      } else if (label === CONSTANT.MATERIAL_TYPE.HTML) {
        this.item.conditions.forEach((element) => {
          element.image_url = null;
        });
      }
    },
    addCondition() {
      this.item.conditions.push(_.cloneDeep(DATA_DRIVEN.ITEM));
    },
    init() {
      this.item.conditions[0].name = "Default";
    },
    checkForm() {
      this.$refs.page2.validate();
    },
    remove() {
      let index = parseInt(this.tab) - 1;
      this.item.conditions.splice(index, 1);
      if (this.item.conditions.length === 1) {
        this.tab = "1";
      }
    },
    setData(row) {
      this.item.material_type = row.material_type;
      this.item.size = `${row.width}x${row.height}`;
      this.item.conditions = _.map(row.conditions, (condition) => {
        return {
          name: condition.name || null,
          landing_page: decodeURI(condition.landing_page),
          image_url: condition.image_url
            ? decodeURI(condition.image_url)
            : null,
          html_url: condition.html_url ? decodeURI(condition.html_url) : null,
          time_duration: condition.time_duration,
          time_duration_display: condition.time_duration_display,
          weather: condition.weather || null,
          weather_display: condition.weather_display,
          humidity_min: condition.humidity_min || null,
          humidity_max: condition.humidity_max || null,
          humidity_display: condition.humidity_display,
          temperature_min: condition.temperature_min || null,
          temperature_max: condition.temperature_max || null,
          temperature_display: condition.temperature_display,
          temperature_unit: condition.temperature_unit,
          pm25_min: condition.pm25_min || null,
          pm25_max: condition.pm25_max || null,
          pm25_display: condition.pm25_display,
          vertical: {
            align: condition.vertical_align,
            padding: condition.vertical_padding,
          },
          horizontal: {
            align: condition.horizontal_align,
            padding: condition.horizontal_padding,
          },
        };
      });
    },
    async getData(setObj) {
      setObj.material_type = this.item.material_type;
      setObj.width = parseInt(this.item.size.split("x")[0]);
      setObj.height = parseInt(this.item.size.split("x")[1]);
      setObj.conditions = _.map(this.item.conditions, (condition) => {
        return {
          name: condition.name,
          landing_page: condition.landing_page.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)),
          image_url: condition.image_url ? condition.image_url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)) : null,
          html_url: condition.html_url ? condition.html_url.replace(/[^\x00-\x7F]/g, (c) => encodeURI(c)) : null,
          time_duration: condition.time_duration,
          time_duration_display: condition.time_duration_display,
          weather: condition.weather,
          weather_display: condition.weather_display,
          humidity_min: condition.humidity_min,
          humidity_max: condition.humidity_max,
          humidity_display: condition.humidity_display,
          temperature_min: condition.temperature_min,
          temperature_max: condition.temperature_max,
          temperature_display: condition.temperature_display,
          temperature_unit: condition.temperature_unit,
          pm25_min: condition.pm25_min,
          pm25_max: condition.pm25_max,
          pm25_display: condition.pm25_display,
          vertical_align: condition.vertical.align,
          vertical_padding: condition.vertical.padding,
          horizontal_align: condition.horizontal.align,
          horizontal_padding: condition.horizontal.padding,
        };
      });
      return setObj;
    },
    minNumberRule(limitedNumber) {
      return [
        {
          trigger: ["blur", "change"],
          validator: (rule, value, callback) => {
            if (limitedNumber === null) {
              callback();
            } else if (value < limitedNumber) {
              callback(new Error(`number must be > ${limitedNumber}`));
            } else {
              callback();
            }
          },
        },
      ];
    },
    maxNumberRule(limitedNumber) {
      return [
        {
          trigger: ["blur", "change"],
          validator: (rule, value, callback) => {
            if (limitedNumber === null) {
              callback();
            } else if (value > limitedNumber) {
              callback(new Error(`number must be < ${limitedNumber}`));
            } else {
              callback();
            }
          },
        },
      ];
    },
  },
};
</script>
<style lang="sass" scoped>
.condtion_graybox
  background-color: #F5F5F5
  padding: 12px 24px 12px
  margin-top: 2px
  &--humidity
    display: flex
    justify-content: space-around
.pm25
  ::v-deep .el-input-group__append
    padding: 0px 5px
::v-deep .el-input__inner
  padding: 0px 0px 0px 15px
::v-deep .el-tabs--card
  .el-tabs__header
    width: 520px
::v-deep .el-form-item__label
  text-align: left
</style>
